import { runningLabel, stepDescription } from '../../domain/stepInfo'
import type { Step, TemplateName } from '../../domain/schemas'
import { Inline, Stack, Text } from '../../ui'

/** A step's name and key, its plain-language description, and what it's doing while it runs. The run page's step rows. */
export function StepTitle({ template, step, n }: { template: TemplateName; step: Pick<Step, 'key' | 'name' | 'status'>; /** Its place in the run, from 1. */ n?: number }) {
  const description = stepDescription(template, step.key)
  const running = step.status === 'running' ? runningLabel(template, step.key) : null
  return (
    <Stack gap="none">
      <Inline gap="sm" align="baseline" wrap={false}>
        {n !== undefined && <Text mono size="xs" tone="muted">{String(n)}</Text>}
        <Inline gap="sm" align="baseline">
          <Text weight="head">{step.name}</Text>
          <Text mono size="xs" tone="muted">{step.key}</Text>
        </Inline>
      </Inline>
      {description && <Text size="sm" tone="muted">{description}</Text>}
      {running && <Text size="sm" tone="accent">{running}</Text>}
    </Stack>
  )
}
